/**
 * Sold-out 409 UI flags. Hide the leftover quote on the same render as
 * the conflict — waiting for a useEffect to set soldOutNoticeTierId is
 * what flashed Intro / $62.10 for ~0.1s.
 */

export const soldOutConflictKey = ({ conflictError, orderTierId } = {}) => {
  if (!conflictError || !orderTierId) {
    return null;
  }
  const marker =
    conflictError.status ||
    conflictError.statusText ||
    conflictError.message ||
    conflictError.code ||
    'conflict';
  return `${orderTierId}:${marker}`;
};

export const checkoutSoldOutUiState = ({
  conflictError,
  orderTierId,
  persistedNoticeTierId,
  ackedConflictKey,
  hasEligiblePriceTier,
} = {}) => {
  const conflictKey = soldOutConflictKey({ conflictError, orderTierId });
  const hideFromConflict = !!conflictKey && conflictKey !== ackedConflictKey;
  const noticeTierId = hideFromConflict ? orderTierId : persistedNoticeTierId || null;
  return {
    conflictKey,
    soldOutNoticeTierId: noticeTierId,
    soldOutNoticeActive: !!noticeTierId && hasEligiblePriceTier === true,
    hidePriceTierGoBack: !!noticeTierId || hasEligiblePriceTier === false,
    hideStaleSoldOutQuote: !!noticeTierId,
    holdAutoPick: !!noticeTierId,
  };
};
